import { AuthLayout } from '@/components/layouts/AuthLayout'
import { EnterOTP } from '@/pages/forgotPassword/EnterOTP'
import { Registration } from '@/pages/registration/Registration'
import { RegistrationBusiness } from '@/pages/registration/RegistrationBusiness'
import { RegistrationIndustries } from '@/pages/registration/RegistrationIndustries'
import { RegistrationStepTwo } from '@/pages/registration/RegistrationStepTwo'
import { RegistrationSuccess } from '@/pages/registration/RegistrationSuccess'
import { RegistrationUploadLogo } from '@/pages/registration/RegistrationUploadLogo'
import { RegistrationYourProfile } from '@/pages/registration/RegistrationYourProfile'
import { Navigate, Route } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

export const RegistrationRoutes = () => {
  const navigate = useNavigate()

  return (
    <>
      <Route path="registration">
        <Route
          index
          element={
            <AuthLayout>
              <Registration
                onLinkClick={(page) => navigate(`/${page}`)}
                onComplete={(email: string) => navigate('/registration/enter-otp', { state: { email } })}
              />
            </AuthLayout>
          }
        />
        <Route
          path="enter-otp"
          element={
            <AuthLayout>
              <EnterOTP
                onLinkClick={(page) => navigate(`/${page}`)}
                onSuccess={(email: string) => navigate('/registration/profile', { state: { email } })}
              />
            </AuthLayout>
          }
        />
        <Route
          path="profile"
          element={
            <AuthLayout>
              <RegistrationYourProfile />
            </AuthLayout>
          }
        />
        <Route
          path="industries"
          element={
            <AuthLayout>
              <RegistrationIndustries />
            </AuthLayout>
          }
        />
        <Route
          path="business"
          element={
            <AuthLayout>
              <RegistrationBusiness />
            </AuthLayout>
          }
        />
        <Route
          path="upload-logo"
          element={
            <AuthLayout>
              <RegistrationUploadLogo />
            </AuthLayout>
          }
        />
        <Route
          path="account-ready"
          element={
            <AuthLayout>
              <RegistrationSuccess />
            </AuthLayout>
          }
        />
        <Route
          path="step-2"
          element={
            <AuthLayout>
              <RegistrationStepTwo
                onPrev={() => {
                  navigate('/login', { replace: true })
                }}
              />
            </AuthLayout>
          }
        />
      </Route>

      <Route path="register" element={<Navigate to="/registration" replace />} />
    </>
  )
}
